/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Linkable } from '@/components/blocks/Linkable';
import { breadcrumbTrailContainerMobSX, breadcrumbTrailContainerSX, scrollRightBtnSx } from '@/components/content/BreadcrumbTrail/styles/container';
import { useBreadcrumbTrail } from '@/data/Content/BreadcrumbTrail';
import { useLocalization } from '@/data/Localization';
import { ID } from '@/data/types/Basic';
import { Box, Breadcrumbs, Typography } from '@mui/material';
import { FC, useEffect, useMemo, useState } from 'react';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { combineSX } from '@/utils/combineSX';
import { sideScroll } from '@/utils/sideScroll';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { getProductListQueryParameters } from '@/data/utils/getProductListQueryParameters';
import { useDeviceType } from '@/data/deviceDetection';

export const BreadcrumbTrail: FC<{ id: ID }> = () => {
	const { breadcrumb, uniqueId, pageName } = useBreadcrumbTrail();
	let tempPageName = pageName;
	// Do this only for Search page . Due to mimic aurora functionality.
	if(pageName?.includes('SearchPage')) {
		const router = useNextRouter();
		const { query } = router; 
		const filteredParams = useMemo(() => getProductListQueryParameters(query), [query]); 
		filteredParams.searchTerm? tempPageName = 'Zoek: '+filteredParams.searchTerm : 'Zoek';
	}
	

	const breadCrumbNLS = useLocalization("BreadCrumb");
	const breadcrumbLength = breadcrumb?.length;
	const {isMobile} = useDeviceType();
	
	const [showScroll, setShowScroll] = useState(false);

	useEffect(()=>{
		const breadcrumbTrail = document.getElementById("breadcrumb-trail") as HTMLElement;
		if(isMobile && breadcrumbTrail){
			const bContanerWidth = (document.getElementById("breadcrumb-trail-container") as HTMLElement)?.clientWidth;
			const breadcrumbTrailWidth =[...breadcrumbTrail?.children]?.at(0)?.clientWidth??0;
			if(breadcrumbTrailWidth > bContanerWidth){
				setShowScroll(true)
			}else setShowScroll(false)
		}
	},[isMobile, breadcrumb])

	const scrollBreadcrumb = () => {
		const breadcumbTrail = document.getElementById("breadcrumb-trail");
		if(breadcumbTrail){
			sideScroll(breadcumbTrail,{direction:'right',speed:25,distance:200,step:20})
		}
	}
	return breadcrumbLength ? (
		<>
			<Box sx={{position:'relative'}} id="breadcrumb-trail-container">
				<Breadcrumbs 
					sx={combineSX([breadcrumbTrailContainerSX, isMobile?breadcrumbTrailContainerMobSX:{}])} 
					aria-label={breadcrumb?.at(-1)?.label} 
					separator={
						"/"
					}
					id="breadcrumb-trail"
				>
					<Linkable href="/">{breadCrumbNLS.Home.t()}</Linkable>
			{breadcrumb.map(({ href, label, trail }, index: number) => (
					<Linkable
						key={`breadcrumb-${uniqueId}-${index}-${label}`}
					href={index < breadcrumbLength - 1 ? href : undefined}
						type={index < breadcrumbLength - 1 ? 'inline' : 'link'}
						data-testid={`breadcrumb-${uniqueId}-${index}-${label}`}
						id={`breadcrumb-${uniqueId}-${index}-${label}`}
					>
						{index < breadcrumbLength - 1 ? (
							label
						) : (
							<Typography variant="body1AsH1">{label}</Typography>
						)}
					</Linkable>
					))}
				</Breadcrumbs>
				{isMobile && showScroll && <Box onClick={scrollBreadcrumb} sx={scrollRightBtnSx}><KeyboardArrowRightIcon /></Box>}
			</Box>
		</>
	) : <Breadcrumbs sx={breadcrumbTrailContainerSX} aria-label={breadcrumb?.at(-1)?.label}>
			<Linkable href="/">{breadCrumbNLS.Home.t()}</Linkable> {tempPageName && <Typography> {tempPageName}</Typography>}		
		</Breadcrumbs>
};